// Cliente de destino de cada conta nos pickers de Google Ads e Meta Ads (#351).
// O cliente é o dono das contas: a conta vai para um cliente existente ou para um novo.
// Helpers puros (sem React e sem rede); o backend revalida tudo.

import { isValidDomain, normalizeDomain } from './url.js'

export const NEW_CLIENT = '__new__'

// Clientes que podem receber contas: os da organização ativa (a API só aceita cliente da org),
// com o cliente próprio (is_self) primeiro.
export function targetClients(clients, organizationId) {
  const list = (clients || []).filter((c) => c && c.id)
  const inOrg = organizationId ? list.filter((c) => c.organization_id === organizationId) : list
  return [...inOrg].sort((a, b) => (
    Number(!!b.is_self) - Number(!!a.is_self) || String(a.name || '').localeCompare(String(b.name || ''), 'pt-BR')
  ))
}

// Escolha inicial: o cliente em que a conta já está (reconexão), senão o cliente selecionado no topo
// do sistema (#355), senão o cliente próprio da org, senão o primeiro; sem cliente nenhum, cria um.
export function defaultTarget(linkedClientId, clients, selectedClientId = null) {
  if (linkedClientId) return linkedClientId
  const list = clients || []
  if (selectedClientId && list.some((c) => c.id === selectedClientId)) return selectedClientId
  const self = list.find((c) => c.is_self)
  return (self || list[0])?.id ?? NEW_CLIENT
}

const clientOf = (row, clients) => (clients || []).find((c) => c.id === row.client) || null

// Pede a URL do site quando o cliente é novo ou ainda não tem uma.
export function needsDomain(row, clients) {
  if (row.client === NEW_CLIENT) return true
  const client = clientOf(row, clients)
  return client ? !client.domain : false
}

// Mensagem de erro da escolha de uma conta, ou null se estiver completa.
export function targetError(row, clients) {
  if (row.client === NEW_CLIENT) {
    if (!String(row.newName || '').trim()) return 'Informe o nome do novo cliente.'
  } else if (!row.client) {
    return 'Escolha o cliente da conta.'
  }
  if (needsDomain(row, clients) && !isValidDomain(row.domain)) {
    return 'Informe uma URL de site válida para o cliente.'
  }
  return null
}

// Campos que o backend recebe por conta (`client_id` ou `client_name`, e `domain` quando pedido).
export function targetPayload(row, clients) {
  const domain = needsDomain(row, clients) ? normalizeDomain(row.domain) : null
  if (row.client === NEW_CLIENT) return { client_name: String(row.newName).trim(), domain }
  return { client_id: row.client, domain }
}
